import { BackendService } from './models';

export const buildServiceBaseUrls = (
  baseUrl?: string | null,
  e2eEnvNamespace?: string
): Record<BackendService, string> => {
  if (e2eEnvNamespace !== undefined) {
    const e2eHost = `https://api-${e2eEnvNamespace}.e2e.sunbit.dev`;

    return {
      [BackendService.Purchase]: `${e2eHost}/${BackendService.Purchase}`,
      [BackendService.LoanApplication]: `${e2eHost}/${BackendService.LoanApplication}`,
    };
  }

  const loanApplicationBaseUrl = baseUrl ?? '';

  return {
    [BackendService.LoanApplication]: loanApplicationBaseUrl,
    [BackendService.Purchase]: loanApplicationBaseUrl.replace(BackendService.LoanApplication, BackendService.Purchase),
  };
};
